<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6KsQ3k/tc-custom/9780300159752.jpg?1704717799596" alt="This image is the cover for the book That Other World"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">That Other World
      </h1>
      <p class="bookDescription body article font2">
        <b>The foundational text for the acclaimed international best seller <i>Reading Lolita in Tehran</i></b><br/><br/><b>“Empathetic, incisive. . . . A sweeping overview of Nabokov's major works. . . . Graceful [and] discerning.”—</b><i><b>Kirkus Reviews</b></i><br/><br/>The ruler of a totalitarian state seeks validation from a former schoolmate, now the nation’s foremost thinker, in order to access a cultural cache alien to his regime. A literary critic provides commentary on an unfinished poem that both foretells the poet’s death and announces the critic’s secret identity as the king of a lost country. The greatest of Vladimir Nabokov’s enchanters—Humbert—is lost within the antithesis of a fairy story, in which Lolita does not hold the key to his past but rather imprisons him within the knowledge of his distance from that past.<br/><br/>In this precursor to her international best seller <i>Reading Lolita in Tehran</i>, Azar Nafisi deftly explores the worlds apparently lost to Nabokov’s characters, their portals of access to those worlds, and how other worlds hold a mirror to Nabokov’s experiences of physical, linguistic, and recollective exile. Written before Nafisi left the Islamic Republic of Iran, and now published in English for the first time and with a new introduction by the author, this book evokes the reader’s quintessential journey of discovery and reveals what caused Nabokov to distinctively shape and reshape that journey for the author.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Azar Nafisi, Lotfali Khonji, Valerie Miles
      </h2>
      
      <p class="authorDescription body article"><B>Azar Nafisi</B> has taught at the University of Tehran, the Free Islamic University, Allameh Tabatabi, and Johns Hopkins University&rsquo;s School of Advanced International Studies. She is the author of <I>Reading Lolita in Tehran: A Memoir in Books</I>, as well as <I>Things I&rsquo;ve Been Silent About: Memories of a Prodigal Daughter</I> and <I>The Republic of Imagination: America in Three Books.</I><br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2916cd86